import { Routes } from '@angular/router';

import { hisChildRoutes } from 'hisng';

import { PublicationSearchFormComponent } from './component/publication/search/publication-search-form.component';
import { PublicationSearchResultComponent } from './component/publication/search/publication-search-result.component';
import { PublicationImportSearchResultComponent } from './component/publication/import/publication-import-search-result.component';
import { PublicationDuplicatesSearchResultComponent } from './component/publication/duplicates/publication-duplicates-search-result.component';
import { PublicationEditFormComponent } from './component/publication/edit/publication-edit-form.component';
import { PublicationViewDetailsComponent } from './component/publication/view/publication-view-details.component';
import { PublicationImportFormComponent } from './component/publication/import/publication-import-form.component';
import { PublicationDuplicatesSearchFormComponent } from './component/publication/duplicates/publication-duplicates-search-form.component';
import { PublicationConfigurationComponent } from './component/publication/configuration/publication-configuration.component';
import { PublicationChangeRequestFormComponent } from './component/publication/change-request/publication-change-request-form';
import { PublicationModuleOptions } from './publication-module.options';

const ROUTES: Routes = [
    {
        path: 'create',
        component: PublicationEditFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_CREATE
        }
    },
    {
        path: 'edit',
        component: PublicationEditFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_EDIT
        }
    },
    {
        path: 'edit/:publicationId',
        component: PublicationEditFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_EDIT
        }
    },
    {
        path: 'change-request/:publicationId',
        component: PublicationChangeRequestFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_CHANGE
        }
    },
    {
        path: 'edit/:publicationId/:parentId',
        component: PublicationEditFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_EDIT
        }
    },
    {
        path: 'search',
        component: PublicationSearchFormComponent,
        data: {
            hasAny: [
                ...PublicationModuleOptions.RIGHT_EDIT,
                ...PublicationModuleOptions.RIGHT_VIEW
            ]
        }
    },
    {
        path: 'searchresult',
        component: PublicationSearchResultComponent,
        data: {
            hasAny: [
                ...PublicationModuleOptions.RIGHT_EDIT,
                ...PublicationModuleOptions.RIGHT_VIEW
            ]
        }
    },
    {
        path: 'importsearchresult',
        component: PublicationImportSearchResultComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_IMPORT
        }
    },
    {
        path: ':mainPublicationId/duplicatessearchresult',
        component: PublicationDuplicatesSearchResultComponent,
        data: {
            hasAny: [
                ...PublicationModuleOptions.RIGHT_EDIT,
                ...PublicationModuleOptions.RIGHT_IMPORT
            ]
        }
    },
    {
        path: 'view/:publicationId',
        component: PublicationViewDetailsComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_VIEW,
            modules: ['HISINONERES']
        }
    },
    {
        path: 'editParent/:publicationId',
        component: PublicationEditFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_EDIT
        }
    },
    {
        path: 'journal',
        loadChildren: () => import( 'app/fs/res/publication/component/journal/journal-core.module' ).then( m => m.JournalCoreModule )
    },
    {
        path: 'conference',
        loadChildren:
            () => import( 'app/fs/res/publication/component/conference/conference-core.module' ).then( m => m.ConferenceCoreModule )
    },
    {
        path: 'publisher',
        loadChildren: () => import( 'app/fs/res/publication/component/publisher/publisher-core.module' ).then( m => m.PublisherCoreModule )
    },
    {
        path: 'import',
        component: PublicationImportFormComponent,
        data: {
            hasAny: PublicationModuleOptions.RIGHT_CREATE
        }
    },
    {
        path: 'searchDuplicates',
        component: PublicationDuplicatesSearchFormComponent,
        data: {
            hasAny: ['RIGHT_CS_SYS_DATABASE_EXECUTE_UPDATE'] // prototype, for admin only
        }
    },
    {
        path: 'configuration',
        component: PublicationConfigurationComponent,
        data: {
            hasAny: ['RIGHT_FS_RES_PUBLICATION_CONFIGURE_PUBLICATION_TYPE_RELATIONSHIP']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PublicationRoutesModule = hisChildRoutes( ROUTES );
